import { render } from "./IntegratedDeviceBoxChild.vue?vue&type=template&id=34bd1f84&scoped=true"
import script from "./IntegratedDeviceBoxChild.vue?vue&type=script&lang=js"
export * from "./IntegratedDeviceBoxChild.vue?vue&type=script&lang=js"

import "./IntegratedDeviceBoxChild.vue?vue&type=style&index=0&id=34bd1f84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bd1f84"]])

export default __exports__